// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e83f0b6f","455":"eca1857b","977":"62fc46b6"}[chunkId] + ".chunk.js";
};